document.addEventListener("DOMContentLoaded", function () {
  const addNewBtn = document.getElementById("open-new-social-fields");
  const addNewSection = document.querySelector(
    ".employee-add-new-social-profile"
  );
  const addProfileBtn = document.getElementById("employee-add-new-scoial");
  const profileGroup = document.querySelector(
    ".form-element-group.social-profile"
  );

  // Toggle visibility of input section
  addNewBtn?.addEventListener("click", function () {
    addNewSection.classList.toggle("d-none");
    if(document.querySelector(".employee-add-new-social-profile-field #social-name")) {
      document.querySelector(".employee-add-new-social-profile-field #social-name").value = '';
    }				
    if(document.querySelector(".employee-add-new-social-profile-field #social-url")) {
      document.querySelector(".employee-add-new-social-profile-field #social-url").value = '';
    }
  });

  // Add new profile
  addProfileBtn?.addEventListener("click", function () {
    const nameInput = addNewSection.querySelector("#social-name");
    const urlInput = addNewSection.querySelector("#social-url");
		const urlPattern = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-./?%&=]*)?$/i;

    const nameValue = nameInput.value.trim();
    const urlValue = urlInput.value.trim();

    if (!nameValue || !urlValue) {
      alert("Please fill in all fields.");
      return;
    }

    if (!urlValue || !urlPattern.test(urlValue)) {
				urlInput.classList.add('is-invalid');
				alert('Please enter a valid URL (e.g., https://example.com)');
				urlInput.focus();
				return;
			}

		// addSocialUrl(nameValue, urlValue);

    // Create new item
    const newItem = document.createElement("div");
    newItem.className =
      "social-profile-item d-flex justify-content-between align-items-center";
    newItem.innerHTML = `
        <div class="social-profile-item-field d-flex justify-content-between align-items-center">
          <div class="form-element">
            <label>Name</label>
            <input type="text" name="social-name[]" value="${nameValue}">
          </div>
          <div class="form-element">
            <label>URL</label>
            <input type="text" name="social-url[]" value="${urlValue}">
          </div>
        </div>
        <button type="button" class="btn btn-delete"><span class="icon icon-delete"></span></button>
      `;

    // Insert new item above the addNewBtn
    profileGroup.insertBefore(newItem, addNewBtn);

    // Clear inputs
    nameInput.value = "";
    urlInput.value = "";

    // Show "Add new" button if hidden
    addNewBtn.classList.remove("d-none");

    // Optionally hide the input form again
    addNewSection.classList.add("d-none");

  });

  // add functionality
  // function addSocialUrl(name, url) {
  //   const socialInput = document.getElementById('employee-social'); //Hidden input
  //   let currentValue = socialInput.value.trim();

  //   // Build the new entry string
  //   const newEntry = `socialName:${name},socialUrl:${url}`;

  //   // If there's existing content, add a semicolon
  //   if (currentValue !== "") {
  //     currentValue += ";" + newEntry;
  //   } else {
  //     currentValue = newEntry;
  //   }

  //   // Update the input value
  //   socialInput.value = currentValue;
  // }

  // Add delete functionality
  document.body.addEventListener("click", function(e) {
    const btn = e.target.closest(".btn-delete");
    if (!btn) return;

    const item = btn.closest(".social-profile-item");
    if (!item) return;

    const name = item.querySelector('input[name="social-name[]"]').value.trim();
    const url = item.querySelector('input[name="social-url[]"]').value.trim();

    const entryToRemove = `socialName:${name},socialUrl:${url}`;

    const socialInput = document.getElementById('employee-social');
    if (socialInput && socialInput.value.trim() !== "") {
      const updatedEntries = socialInput.value
        .trim()
        .split(";")
        .filter(entry => entry.trim() !== entryToRemove);

      socialInput.value = updatedEntries.join(";");
    }

    item.remove();

    const remaining = document.querySelectorAll(".social-profile-item");
    if (remaining.length === 0) {
      // addNewSection.classList.remove("d-none");
    }
  });
});